import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/lib/legal-content";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
  head: () => ({
    meta: [
      { title: "Privacy Policy — CoderLity" },
      { name: "description", content: "How CoderLity collects, uses and protects your personal information across our websites and services." },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/privacy" }],
  }),
});

function PrivacyPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Privacy Policy"
      sub="Your data, handled with the same care we'd expect for our own."
      updated="May 1, 2026"
      sections={[
        { heading: "Information we collect", body: "We collect information you provide directly (name, email, billing details), data generated by your use of our services (logs, device, usage), and information from third parties (payment providers, analytics)." },
        { heading: "How we use information", body: "To deliver and improve our services, process payments, prevent fraud, communicate with you about updates, and comply with legal obligations." },
        { heading: "Sharing", body: "We never sell personal data. We share only with vetted processors (hosting, payments, analytics) under strict contracts, or when required by law." },
        { heading: "Your rights", body: "You may request access, correction, export or deletion of your data at any time by writing to privacy@coderlity.com." },
        { heading: "Contact", body: "Questions? Email privacy@coderlity.com." },
      ]}
    />
  );
}
